import $okgportal_api from "@/shared/client/okgportal.client";
import { BaseOkgportalResponce } from "@/shared/model/api.types";
import { CompanyInterface } from "../model/HeaderDashboardStore.model";

class CompanyApi {
  async searchByInnOrName(str: string){
    try {
      const response = await $okgportal_api.get<BaseOkgportalResponce<CompanyInterface[]>>(`/company/search/${str}`);
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export default new CompanyApi();